import React from 'react';
import { List, Brain, Clock, Globe } from 'lucide-react';

const Features = ({ language }) => {
  const texts = {
    no: {
      title: 'Kraftige AI-funksjoner for moderne kokker',
      subtitle: 'Opplev revolusjonerende teknologi som forvandler din kjøkkenopplevelse',
      features: [
        {
          icon: List,
          title: 'Ingrediens Database',
          description: 'Omfattende database med tusenvis av ingredienser og deres egenskaper'
        },
        {
          icon: Brain,
          title: 'Intelligent Matching',
          description: 'Vår AI finner de perfekte oppskriftene basert på dine ingredienser og smakspreferanser'
        },
        {
          icon: Clock,
          title: 'Rask Behandling',
          description: 'Få personlige oppskrifter på under 30 sekunder med vår høytytende AI-motor'
        },
        {
          icon: Globe,
          title: 'Global Matkultur',
          description: 'Utforsk oppskrifter fra hele verden, tilpasset til din lokale smak og tilgjengelige ingredienser'
        }
      ]
    },
    en: {
      title: 'Powerful AI Features for Modern Chefs',
      subtitle: 'Experience revolutionary technology that transforms your cooking experience',
      features: [
        {
          icon: List,
          title: 'Ingredient Database',
          description: 'Comprehensive database with thousands of ingredients and their properties'
        },
        {
          icon: Brain,
          title: 'Intelligent Matching',
          description: 'Our AI finds the perfect recipes based on your ingredients and taste preferences'
        },
        {
          icon: Clock,
          title: 'Fast Processing',
          description: 'Get personalized recipes in under 30 seconds with our high-performance AI engine'
        },
        {
          icon: Globe,
          title: 'Global Cuisine',
          description: 'Explore recipes from around the world, tailored to your local taste and available ingredients'
        }
      ]
    }
  };

  const t = texts[language];

  return (
    <section id="section-2" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            {t.title}
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            {t.subtitle}
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {t.features.map((feature, index) => (
            <div
              key={index}
              className="bg-gradient-to-br from-green-50 to-emerald-50 rounded-2xl p-8 hover:shadow-lg transition-all duration-300 hover:-translate-y-1"
            >
              <div className="w-16 h-16 bg-green-600 rounded-2xl flex items-center justify-center mb-6">
                <feature.icon className="w-8 h-8 text-white" />
              </div>
              
              <h3 className="text-xl font-semibold text-gray-900 mb-4">
                {feature.title}
              </h3>
              
              <p className="text-gray-600 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>

        {/* AI Recipe Preview */}
        <div className="mt-16 text-center">
          <div className="relative inline-block">
            <img
              src="/images/ai-recipe.png"
              alt="AI Recipe Generation Interface"
              className="w-full max-w-2xl rounded-2xl shadow-2xl"
            />
            <div className="absolute -top-4 -right-4 bg-green-600 text-white px-6 py-3 rounded-full text-lg font-semibold shadow-lg">
              {language === 'no' ? 'AI-rettigheter i sanntid' : 'AI Recipes in Real-time'}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Features;
